export enum QualitiesEnum {

    quality1 = 'quality1',
    quality2 = 'quality2',
    quality3 = 'quality3',
    quality4 = 'quality4',
    quality5 = 'quality5',
    quality6 = 'quality6',
    quality7 = 'quality7',
    quality8 = 'quality8',
    quality9 = 'quality9',
    quality10 = 'quality10',
    quality11 = 'quality11',
    quality12 = 'quality12',


  }